// ゲストアプリのカラー定数。
// テーマカラー: #28233B (primary)、サブテーマカラー: #C9A063 (secondary)
export const colors = {
  // ヘッダー
  headerText: "#FFFFFF",
  headerSubText: "rgba(255, 255, 255, 0.7)",

  // ブランド
  brand: "#FFFFFF",

  // アクセント (ゴールド)
  gold: "#C9A063",
  goldLight: "#D4B07A",
  goldDark: "#A87F45",

  // 背景
  appBg: "#FFFFFF",
  pageBg: "#F8F6F2",
  surface: "#FFFFFF",
  surfaceMuted: "#F5F3EF",

  // テキスト
  text: "#1A1628",
  textBody: "#3D3856",
  textSub: "#6B6585",
  textMuted: "#9B96AE",

  // 罫線
  border: "#E5E0F0",
  borderSoft: "#EDE9F5",
  divider: "#E8E4F0",

  // フッター
  footerText: "rgba(255, 255, 255, 0.7)",
  footerTextHover: "#FFFFFF",

  // エラー / 成功
  danger: "#CF5346",
  success: "#3D8A5F",

  // ミシュラン星チップ (テーマカラー #28233B のトーンに沿った落ち着いた赤)
  michelin: "#A63D4F",
  // 空席ありピル (テーマカラー #28233B のトーンに沿った落ち着いた緑)
  availability: "#4E7A5E",
  // 空席なしピル (テーマカラー #28233B のトーンに沿った落ち着いた赤)
  availabilityNone: "#A65A50",
} as const;
